import React, { useState } from 'react';
import { Calendar, CheckCircle, User, Clock, Sparkles, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { MobileLayout } from '../components/MobileLayout';
import { PianificaPuliziaWizard } from '../components/PianificaPuliziaWizard';
import { Tabs } from '../components/ui/Tabs';
export function PuliziePage() {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<'gestione' | 'opportunita'>('gestione');
  // Mock data for upcoming cleanings
  const prossimePulizie = [{
    id: '1',
    property: 'Villa Sunset',
    date: 'Mer 17 Gen',
    time: '11:00 - 15:00',
    status: 'in_corso',
    cleaner: 'Francesca N.',
    cleanerImg: 'https://cdn.magicpatterns.com/uploads/g4qUZyyXcdzW3wf29pvDcz/Screenshot_2026-03-22_alle_16.12.18.png',
    isShareable: true
  }, {
    id: '2',
    property: 'Villa Sunset',
    date: 'Ven 19 Gen',
    time: '12:00 - 14:30',
    status: 'pianificata',
    cleaner: 'Roberto F.',
    cleanerImg: '',
    isShareable: false
  }];
  // Mock data for completed cleanings
  const pulizieCompletate = [{
    id: '3',
    property: 'Villa Sunset',
    date: 'Lun 15 Gen',
    duration: '3h 30min',
    cleaner: 'Francesca N.',
    aiScore: 98,
    isShareable: true
  }, {
    id: '4',
    property: 'Villa Sunset',
    date: 'Ven 12 Gen',
    duration: '4h',
    cleaner: 'Roberto F.',
    aiScore: 100,
    isShareable: false
  }];
  const shareableProssime = prossimePulizie.filter(p => p.isShareable);
  const shareableCompletate = pulizieCompletate.filter(p => p.isShareable);
  const totalShareable = shareableProssime.length + shareableCompletate.length;
  return <MobileLayout data-id="element-3593">
      {/* Header */}
      <div className="flex items-center justify-between mb-5" data-id="element-3594">
        <h1 className="text-xl lg:text-2xl font-bold text-foreground" data-id="element-3595">
          Pulizie
        </h1>
      </div>

      {/* Tabs */}
      <Tabs className="mb-6" value={activeTab} onValueChange={id => setActiveTab(id as 'gestione' | 'opportunita')} items={[{
      id: 'gestione',
      label: 'Gestione'
    }, {
      id: 'opportunita',
      label: 'Opportunità',
      badge: totalShareable > 0 ? <span className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold bg-coral text-white rounded-full" data-id="element-3597">
                  {totalShareable}
                </span> : undefined
    }]} data-id="element-3596" />

      {/* TAB: Gestione */}
      {activeTab === 'gestione' && <>
          {/* In corso / Prossime */}
          <div className="mb-8" data-id="element-3598">
            <div className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-3" data-id="element-3599">
              In corso e prossime
            </div>

            <div className="space-y-3" data-id="element-3600">
              {prossimePulizie.map(pulizia => {
            const isInProgress = pulizia.status === 'in_corso';
            return <Link key={pulizia.id} to={`/pulizia-dettaglio?status=${isInProgress ? 'in_corso' : 'pianificata'}`} className="block bg-white border border-border rounded-xl p-4 hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-3601">
                    <div className="flex justify-between items-start mb-3" data-id="element-3602">
                      <div data-id="element-3603">
                        <h3 className="text-sm font-semibold text-foreground" data-id="element-3604">
                          {pulizia.property}
                        </h3>
                        <div className="flex items-center gap-3 mt-1 text-xs text-muted-foreground" data-id="element-3605">
                          <span className="flex items-center gap-1" data-id="element-3606">
                            <Calendar size={12} data-id="element-3607" />
                            {pulizia.date}
                          </span>
                          <span className="flex items-center gap-1" data-id="element-3608">
                            <Clock size={12} data-id="element-3609" />
                            {pulizia.time}
                          </span>
                        </div>
                      </div>
                      <span className={`text-[10px] font-medium px-2 py-1 rounded-full border ${isInProgress ? 'bg-coral/5 text-coral border-coral/20' : 'bg-muted text-muted-foreground border-border'}`} data-id="element-3610">
                        {isInProgress ? '● In corso' : 'Pianificata'}
                      </span>
                    </div>

                    <div className="flex items-center justify-between" data-id="element-3611">
                      <div className="flex items-center gap-2" data-id="element-3612">
                        {pulizia.cleanerImg ? <img src={pulizia.cleanerImg} alt={pulizia.cleaner} className="w-7 h-7 rounded-full object-cover" data-id="element-3613" /> : <div className="w-7 h-7 rounded-full bg-muted flex items-center justify-center" data-id="element-3614">
                            <User size={14} className="text-muted-foreground" data-id="element-3615" />
                          </div>}
                        <span className="text-xs text-muted-foreground" data-id="element-3616">
                          {pulizia.cleaner}
                        </span>
                      </div>
                      <ChevronRight size={16} className="text-muted-foreground" data-id="element-3617" />
                    </div>
                  </Link>;
          })}
            </div>
          </div>

          {/* Completate */}
          <div className="mb-6" data-id="element-3618">
            <div className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-3" data-id="element-3619">
              Completate di recente
            </div>

            <div className="space-y-3" data-id="element-3620">
              {pulizieCompletate.map(pulizia => <Link key={pulizia.id} to="/pulizia-dettaglio?status=completata" className="bg-white border border-border rounded-xl p-4 flex items-center justify-between hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-3621">
                  <div data-id="element-3622">
                    <h3 className="text-sm font-medium text-foreground mb-1" data-id="element-3623">
                      {pulizia.property}
                    </h3>
                    <div className="flex items-center gap-3 text-xs text-muted-foreground" data-id="element-3624">
                      <span className="flex items-center gap-1" data-id="element-3625">
                        <Calendar size={12} data-id="element-3626" />
                        {pulizia.date}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-3627">
                        <Clock size={12} data-id="element-3628" />
                        {pulizia.duration}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-4" data-id="element-3629">
                    <div className="flex flex-col items-end" data-id="element-3630">
                      <span className="text-[10px] text-muted-foreground uppercase tracking-wider font-medium mb-0.5" data-id="element-3631">
                        AI Check
                      </span>
                      <span className="inline-flex items-center gap-1 text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-1 rounded-md border border-emerald-100" data-id="element-3632">
                        <CheckCircle size={12} data-id="element-3633" />
                        {pulizia.aiScore}/100
                      </span>
                    </div>
                    <ChevronRight size={16} className="text-muted-foreground" data-id="element-3634" />
                  </div>
                </Link>)}
            </div>
          </div>
        </>}

      {/* TAB: Opportunità */}
      {activeTab === 'opportunita' && <div className="mb-8" data-id="element-3635">
          <div className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-3 flex items-center gap-1.5" data-id="element-3636">
            <Sparkles size={12} className="text-coral" data-id="element-3637" />
            Pulizie condivisibili
          </div>

          {totalShareable === 0 ? <div className="bg-white border border-border rounded-xl p-8 text-center" data-id="element-3638">
              <p className="text-sm text-muted-foreground" data-id="element-3639">
                Nessuna pulizia condivisibile al momento.
              </p>
            </div> : <div className="space-y-3" data-id="element-3640">
              {shareableProssime.map(pulizia => {
          const isInProgress = pulizia.status === 'in_corso';
          return <Link key={pulizia.id} to={`/pulizia-dettaglio?status=${isInProgress ? 'in_corso' : 'pianificata'}`} className="block bg-white border border-border rounded-xl p-4 hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-3641">
                    <div className="flex justify-between items-start mb-3" data-id="element-3642">
                      <div data-id="element-3643">
                        <h3 className="text-sm font-semibold text-foreground" data-id="element-3644">
                          {pulizia.property}
                        </h3>
                        <div className="flex items-center gap-3 mt-1 text-xs text-muted-foreground" data-id="element-3645">
                          <span className="flex items-center gap-1" data-id="element-3646">
                            <Calendar size={12} data-id="element-3647" />
                            {pulizia.date}
                          </span>
                          <span className="flex items-center gap-1" data-id="element-3648">
                            <Clock size={12} data-id="element-3649" />
                            {pulizia.time}
                          </span>
                        </div>
                      </div>
                      <span className={`text-[10px] font-medium px-2 py-1 rounded-full border ${isInProgress ? 'bg-coral/5 text-coral border-coral/20' : 'bg-muted text-muted-foreground border-border'}`} data-id="element-3650">
                        {isInProgress ? '● In corso' : 'Pianificata'}
                      </span>
                    </div>

                    <div className="flex items-center justify-between" data-id="element-3651">
                      <div className="flex items-center gap-2" data-id="element-3652">
                        {pulizia.cleanerImg ? <img src={pulizia.cleanerImg} alt={pulizia.cleaner} className="w-7 h-7 rounded-full object-cover" data-id="element-3653" /> : <div className="w-7 h-7 rounded-full bg-muted flex items-center justify-center" data-id="element-3654">
                            <User size={14} className="text-muted-foreground" data-id="element-3655" />
                          </div>}
                        <span className="text-xs text-muted-foreground" data-id="element-3656">
                          {pulizia.cleaner}
                        </span>
                      </div>
                      <ChevronRight size={16} className="text-muted-foreground" data-id="element-3657" />
                    </div>
                  </Link>;
        })}

              {shareableCompletate.map(pulizia => <Link key={pulizia.id} to="/pulizia-dettaglio?status=completata" className="bg-white border border-border rounded-xl p-4 flex items-center justify-between hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-3658">
                  <div data-id="element-3659">
                    <h3 className="text-sm font-medium text-foreground mb-1" data-id="element-3660">
                      {pulizia.property}
                    </h3>
                    <div className="flex items-center gap-3 text-xs text-muted-foreground" data-id="element-3661">
                      <span className="flex items-center gap-1" data-id="element-3662">
                        <Calendar size={12} data-id="element-3663" />
                        {pulizia.date}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-3664">
                        <Clock size={12} data-id="element-3665" />
                        {pulizia.duration}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-4" data-id="element-3666">
                    <div className="flex flex-col items-end" data-id="element-3667">
                      <span className="text-[10px] text-muted-foreground uppercase tracking-wider font-medium mb-0.5" data-id="element-3668">
                        AI Check
                      </span>
                      <span className="inline-flex items-center gap-1 text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-1 rounded-md border border-emerald-100" data-id="element-3669">
                        <CheckCircle size={12} data-id="element-3670" />
                        {pulizia.aiScore}/100
                      </span>
                    </div>
                    <ChevronRight size={16} className="text-muted-foreground" data-id="element-3671" />
                  </div>
                </Link>)}
            </div>}
        </div>}

      {/* Wizard Modal */}
      <PianificaPuliziaWizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} data-id="element-3672" />
    </MobileLayout>;
}